import React, { useRef, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { EnhancedTable, ConfigContext } from '../../lib';
import EmailCampaignAddModal from './EmailCampaignAddModal';
import {
    Box,
    Button
} from '@mui/material';

export default function EmailCampaignGrid() {
    const gridRef = useRef();
    const navigate = useNavigate();
    const { config } = useContext(ConfigContext);
    const [emailCampaignAddModalIsOpen, setEmailCampaignAddModalIsOpen] = useState(false);

    const headCells = [
        { id: 'name', numeric: false, disablePadding: true, label: 'Name' },
        { id: 'description', numeric: false, disablePadding: true, label: 'Description' },
        { id: 'startDate', numeric: false, disablePadding: true, label: 'Start Date' },
        { id: 'endDate', numeric: false, disablePadding: true, label: 'End Date' },
        { id: 'status', numeric: false, disablePadding: true, label: 'Status' },
        { id: 'campaignType', numeric: false, disablePadding: true, label: 'Campaign Type' },
    ];

    const filterList = [
        { id: 'name', dataType: 'string', label: 'Name', defaultValue: '' },
        { id: 'description', dataType: 'string', label: 'Description', defaultValue: '' },
        { id: 'startDate', dataType: 'string', label: 'Start Date', defaultValue: '' },
        { id: 'endDate', dataType: 'string', label: 'End Date', defaultValue: '' },
        { id: 'status', dataType: 'string', label: 'Status', defaultValue: '' },
        { id: 'campaignType', dataType: 'string', label: 'Campaign Type', defaultValue: '' },
    ];

    return (
        <div>
            <Box display="flex" justifyContent="flex-end" mb={2}>
                <Button variant="contained" color="primary" onClick={() => setEmailCampaignAddModalIsOpen(true)}>
                    Add Campaign
                </Button>
            </Box>
            <EmailCampaignAddModal
                config={config}
                isOpen={emailCampaignAddModalIsOpen}
                onChangeBulk={setEmailCampaignAddModalIsOpen}
            />
            <EnhancedTable
                ref={gridRef}
                tableName="Email Campaigns"
                searchEndpont={`${config.uri.base}/email-campaign`}
                actionRowClick={({ rowData }) => navigate(`/admin/email-campaign/${rowData._id}`)}
                actionDelete={async () => {
                    location.reload();
                }}
                headCells={headCells}
                filterList={filterList}
            />
        </div>
    );
}
